class RenderHtml {
    constructor(dataPost, dataLoadmore) {
        this.dataPost = dataPost;
        this.dataLoadmore = dataLoadmore;
    }
    render() {
        var _a;
        if (this.dataPost.code !== 200) {
            (_a = this.dataLoadmore.wrapList) === null || _a === void 0 ? void 0 : _a.insertAdjacentHTML('beforeend', this.dataPost.response.message);
            return false;
        }
        switch (this.dataLoadmore.type) {
            case 'ACT_LOADMORE_SEARCH':
                this.htmlLoadmoreSearch();
                break;
            case 'ACT_LOADMORE_CATEGORY':
                this.htmlLoadmoreSearch();
                break;
            default:
                break;
        }
    }
    htmlLoadmoreSearch() {
        var _a;
        let html = '';
        this.dataPost.response.data.posts.map(post => {
            html += `
      <div class="col post-item">
        <div class="col-inner">
          <a href="${post.postPermalink}" class="plain">
            <div class="box box-text-bottom box-blog-post has-hover">
              <div class="box-image">
  						  <div class="image-cover" style="padding-top:63%;">
  							  ${post.postImage}
                </div>
  						</div>
              <div class="box-text text-left">
                <div class="box-text-inner blog-post-inner">
                  <h5 class="post-title is-large">${post.postTitle}</h5>
                  <div class="is-divider"></div>
                  <p class="from_the_blog_excerpt">${post.postDesc}</p>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      `;
        });
        (_a = this.dataLoadmore.wrapList) === null || _a === void 0 ? void 0 : _a.insertAdjacentHTML('beforeend', html);
    }
}
export default RenderHtml;
